import { Spin } from "antd";

import styles from "./style.module.scss";

const LoadingView = () => {
  return (
    <div className={styles.container}>
      <Spin />
    </div>
  );
};

export default LoadingView;
